import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { appActions, appSelectors } from 'app/redux';
import { Spinner } from 'common/statusIndicators';
import * as NAVIGATION from 'config/navigation';
import * as authApi from 'service/auth';
import { hasPermission } from 'service/utility/auth';

const PrivateRoute = ({
  accessToken,
  setAccessToken,
  usuario,
  setUsuario,
  setEmpresa,
  requiredPermission,
  passwordChangeRoute,
  children,
}) => {
  const localToken = localStorage.getItem('accessToken');
  const token = accessToken || localToken;

  useEffect(() => {
    if (!accessToken && localToken) {
      setAccessToken(localToken);
    }
  }, [accessToken, localToken, setAccessToken]);

  useEffect(() => {
    if (!token || usuario?.codUsuario) return undefined;

    let active = true;

    const getAuthInfo = async () => {
      const data = await authApi.authInfo();

      if (active && data) {
        const response = data.data;

        setUsuario(response);
        setEmpresa(response.empresa);
      }
    };

    getAuthInfo();

    return () => {
      active = false;
    };
  }, [setEmpresa, setUsuario, token, usuario?.codUsuario]);

  if (!token) return <Navigate to={NAVIGATION.LOGIN} replace />;

  if (!usuario || !usuario.codUsuario) {
    return <Spinner />;
  }

  if (usuario.passwordChangeRequired && !passwordChangeRoute) {
    return <Navigate to={NAVIGATION.CHANGE_PASSWORD} replace />;
  }

  if (!usuario.passwordChangeRequired && passwordChangeRoute) {
    return <Navigate to={NAVIGATION.HOME} replace />;
  }

  if (Boolean(requiredPermission) && !hasPermission(requiredPermission, usuario)) {
    return <Navigate to={NAVIGATION.NOT_ALLOWED} replace />;
  }

  return children;
};

PrivateRoute.propTypes = {
  accessToken: PropTypes.string,
  children: PropTypes.node,
  requiredPermission: PropTypes.string,
  passwordChangeRoute: PropTypes.bool,
  setAccessToken: PropTypes.func,
  setEmpresa: PropTypes.func,
  setUsuario: PropTypes.func,
  usuario: PropTypes.object,
};

const mapStateToProps = (state) => ({
  accessToken: appSelectors.accessToken(state),
  usuario: appSelectors.usuarioActual(state),
});

const mapDispatchToProps = (dispatch) => ({
  setAccessToken: (accessToken) => dispatch(appActions.setAccessToken(accessToken)),
  setUsuario: (user) => dispatch(appActions.setUsuario(user)),
  setEmpresa: (empresa) => dispatch(appActions.setEmpresa(empresa)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);
